export const Modules = {
  PROJECT: "project",
  TEAM: 'team',
  PROJECT_CORE_DOCUMENT: 'project core document',
  DOCUMENT: 'document',
  STAKEHOLDER: 'stakeholder',
  PROJECT_TYPE: 'project type',
  RISK_MANAGEMENT: "risk management",
  RISK: "risk",
  RISK_MITIGATION: "risk mitigation",
  FINANCE: "finance",
  RATE: "rate",
  USER: "user",
  WORKFLOW: "workflow",
  TICKET: "ticket",
  SPRINT: "sprint",
  PROJECT_PLANNING: "project planning",
  DOCUMENTATION: "documentation",
  AGENDA: "agenda",
  REQUEST: "request",
  PORTFOLIO_TYPE: "incubator type",
  PORTFOLIO: "portfolio",
  MILESTONE: "milestone",
  ESCALATION: "escalation",
  APPROVAL: "approval",
  APPROVAL_USER: "approval user",
  TASK: "task",
  PROJECT_CHALLENGE: 'project challenge',
  COMMENT: "comment",
  DOCUMENT_ASSOCIATION: "documentAssociation",
  PROJECT_DELIVERABLE: "projectDeliverable",
  STATUS: "status",
  PRIORITY: "priority",
  CHANGE_REQUEST: "change request",
  DELIVERABLE: "deliverable",
  CONTACT: 'contact',
  ITEM: 'item',
  SUCCESS_STORY: 'success story'
};

export const ActionModule = {
  // PROJECT_SUBMISSION_APPROVAL: "Project Submission",
  // PROJECT_APPROVAL: "Project Approval",
  PROJECT: "project",
  CHANGE_REQUEST: "changeRequest",
  MILESTONE: "milestone",
  DELIVERABLE: "deliverable"
}

export const TabModule = {
  TASK_CHANGE_REQUEST: "Task Change Request",
  TASK_OVERVIEW: "Task Overview",
  MILESTONE_CHANGE_REQUEST: "Milestone Change Request",
  MILESTONE_OVERVIEW: "Milestone Overview",
  MILESTONE_APPROVAL: "Milestone Approval",
  MILESTONE_SUBMISSION: "Milestone Submission Approval",
  PROJECT_APPROVAL: "Project Approval",
  PROJECT_SUBMISSION_APPROVAL: "Project Submission Approval",
  RISK_OVERVIEW: "Risk Overview",
  CHANGE_REQUEST_APPROVAL: "Change Request Approval",
  CHANGE_REQUEST: "Change Request",
  DELIVERABLE_SUBMISSION: "Deliverable Submission Approval",
};

export const ChangeRequestModule = {
  PROJECT: "project",
  TICKET: "ticket",
  MILESTONE: "milestone",
  DELIVERABLE: "deliverable",
  PROJECT_USER: "projectUser",
};

export const DocumentModule = {
  PROJECT: "project",
  TICKET: "ticket",
  MILESTONE_BUDGET: "milestoneBudget",
  MILESTONE: 'milestone',
  DELIVERABLE: 'deliverable',
  PROJECT_DELIVERABLE: "projectDeliverable",
};

export const ApprovalModule = {
  PROJECT: "project",
  CHANGE_REQUEST: "changeRequest",
};

export const ActivityModule = {
  PROJECT: "project",
  DELIVERABLE: "deliverable",
  MILESTONE: "milestone",
  MILESTONE_BUDGET: "milestoneBudget",
  RISK: "risk",
  SUCCESS_STORY: "SuccessStories",
  APPROVAL: "approval",
  APPROVAL_USER: "approvalUser",
  PROJECT_USER: "projectUser",
  CHANGE_REQUEST: "changeRequest",
  CHANGE_REQUEST_ITEM: "changeRequestItem",
  PROJECT_DELIVERABLE: "projectDeliverable"
};
